﻿$.fn.dxCtrlFichier2Document = function custom_dxCtrlFichier2Document(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlfichier2document dx-ctrl");
        this.createInstance(new cdxCtrlFichier2Document(this, option));
    }
    return this;
}

window.cdxCtrlFichier2Document = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var _isDirty = false
    this.isDirty = function (value) {
        if (typeof value != 'undefined') _isDirty = value
        return _isDirty
    }

    var dataSourceObjet = []
    function mConstruit() {
        container.empty()
        dataSourceObjet = []
        option.dataSource.forEach(function (url) {
            dataSourceObjet.push({ url: url })
        })
        $("<div style='width:100%;height:100%;'/>").appendTo(container).dxCtrlFichier2Resume({
            bddCtrl: option.bddCtrl,
            dataSource: dataSourceObjet,
            typeVisu: option.typeVisu,
            readOnly: option.readOnly,
            containerBtAdd: option.containerBtAdd,
            downloadFile: option.downloadFile,
            imgInternet: option.imgInternet,
            box: option.box,
            icone: option.icone,
            docCpt: option.docCpt,
            courrier: option.courrier,
            onReorder: function (itemData) {
                _isDirty = true
            },
            onDeleteFiles: function (lstItemDataToDel) {
                lstItemDataToDel.forEach(function (itemData) {
                    dataSourceObjet.splice(dataSourceObjet.indexOf(itemData), 1)
                })
                if (typeof option.onDeleteFiles != 'undefined') option.onDeleteFiles(Me.mGetLstUrlFile())
                _isDirty = true
                if (typeof option.onAdd != 'undefined') option.onDelete()
                option.dataSource = []
                dataSourceObjet.forEach(function (data) {
                    option.dataSource.push(data.url)
                })
            },
            onAddFiles: function (lstNewUrlFile, funcOk) {
                _isDirty = true
                var lstNewItemData = []
                lstNewUrlFile.forEach(function (url) {
                    var item = { url: url }
                    dataSourceObjet.push(item)
                    lstNewItemData.push(item)
                })
                funcOk(lstNewItemData)
                if (typeof option.onAdd != 'undefined') option.onAdd()
                option.dataSource = []
                dataSourceObjet.forEach(function (data) {
                    option.dataSource.push(data.url)
                })
            },
            onModifFiles: function (lstFiles) {
                _isDirty = true
            }
        })
    }

    this.mAddFiles = function (lstUrlFiles) {
        lstUrlFiles.forEach(function (url) {
            option.dataSource.push(url)
        })
        mConstruit()
    }

    this.mClearFiles = function () {
        _isDirty = true
        option.dataSource = []
        mConstruit()
    }

    this.mGetLstUrlFile = function () {
        var lst = []
        dataSourceObjet.forEach(function (itemData) {
            lst.push(itemData.url)
        })
        return lst
    }

    this.element = function () { return container; }
    this.component = function () { return dx; }
    //this.dispose = function () {

    //}

    mConstruit();
}